import http from "@/api.js";

export default {
    emits: ["file-start-upload", "file-end-upload", "file-progress-upload"],
    name: 'file-mixin',
    data: () => ({
        dataroomfolderUpload: null,
        dataroominputUpload: null,
        files_on_upload: {},
        file_url_api_suffix: "",
    }),
    computed: {
        file_url_api(){
            return "/api/"+this.$route.params.groupUid+this.fileapi;
        },
        document_url_api(){
            return "/api/"+this.$route.params.groupUid+this.documentapi;
        }
    },
    methods: {
        startUploadFiles(folder){
            this.dataroomfolderUpload = folder;
            this.dataroominputUpload = document.createElement("input");
            this.dataroominputUpload.setAttribute("type", "file");
            this.dataroominputUpload.setAttribute("multiple", "false");
            this.dataroominputUpload.setAttribute("style", "display: none");
            this.dataroominputUpload.addEventListener("change", this.doUploadFiles);
            this.dataroominputUpload.addEventListener("cancel", this.doUploadFiles);
            document.body.appendChild(this.dataroominputUpload);
            this.dataroominputUpload.click();
        },
        async doUploadFiles($event){
            if($event.target.files.length){
                const files = $event.target.files;
                // Show each files before start upload
                for (let i = 0; i < files.length; i++) {
                    this.$emit("file-start-upload", {folder: this.dataroomfolderUpload, file: files[i]});
                    await http.postForm(this.file_url_api, {
                        file: files[i],
                        folder: this.dataroomfolderUpload.uid,
                        config: {},
                    }, {
                        onUploadProgress: (progressEvent) => {
                            let percent = Math.round((progressEvent.loaded * 100) / progressEvent.total);
                            this.$emit("file-progress-upload", {file: files[i], percent});
                        }
                    })
                    this.$emit("file-end-upload", {folder: this.dataroomfolderUpload, file: files[i]});
                }
                this.reloadFolder(this.dataroomfolderUpload.uid);
            }
            this.dataroominputUpload.removeEventListener("change", this.doReplaceDocument);
            this.dataroominputUpload.removeEventListener("cancel", this.doReplaceDocument);
            document.body.removeChild(this.dataroominputUpload);
            this.dataroominputUpload = null;
            this.dataroomfolderUpload = null;
        },
    }
}
